// src/Components/NavBar.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/om logo.jpeg";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // scroll detect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed w-full z-50 transition-all duration-500 bg-white shadow-md ${
          scrolled ? "nav-curved" : ""
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">

            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/">
                <img
                  src={logo}
                  alt="Logo"
                  className={`transition-all duration-500 ${
                    scrolled ? "h-12" : "h-16"
                  }`}
                />
              </Link>
            </div>

            {/* Desktop Links */}
            <div className="hidden md:flex space-x-6 items-center">
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/">Home</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/about">About</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/services">Services</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/courses">Courses</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/blogs">Blogs</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/carrer">Career</Link>
              <Link className="text-gray-700 text-lg hover:text-red-600" to="/contact">Contact</Link>

              <Link to="/request">
                <button className="bg-red-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors cursor-none">
                 Request a Quote
                </button>
              </Link>
            </div>

            {/* Mobile Button */}
            <div className="md:hidden flex items-center cursor-none">
              <button onClick={() => setIsOpen(!isOpen)}>
                ☰
              </button>
            </div>

          </div>
        </div>

      </nav>

      {/* CURVED EFFECT (ONLY ADDITION) */}
      <style>
        {`
          .nav-curved {
            margin: 10px 20px;
            width: calc(100% - 40px);
            border-radius: 0 0 35px 35px;
            backdrop-filter: blur(20px);
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
            transition: all 0.5s ease;
          }
        `}
      </style>
    </>
  );
};

export default NavBar;